/** @jsxImportSource @emotion/react */
import { memo } from "react";

import MailAddress from "components/parts/MailAddress";

/**
 * メールアドレス（確認あり）
 * @param {String} label ラベル
 * @param {Boolean} required true : 必須
 *                           false: 任意
 * @param {String} name react-hook-form管理用フォーム特定文字列
 * @param {String} maxLength 最大文字数
 * @param {Object} matchValid バリデーション一致判定用オブジェクト
 * @param {String} txtCaption 注釈
 */
const MailAddressAgain = memo(({ label, required, name, maxLength, txtCaption }) => {
  return (
    <>
      {/** メールアドレス */}
      <MailAddress
        label={label}
        required={required}
        name={name}
        matchValid={{
          targetName: name + "Again",
          message: "メールアドレスがメールアドレス（確認）と一致していません。",
        }}
        maxLength={maxLength}
        txtCaption={txtCaption}
      ></MailAddress>

      {/** メールアドレス（確認） */}
      <MailAddress
        label={label + "（確認）"}
        required={required}
        name={name + "Again"}
        matchValid={{
          targetName: name,
          message: "メールアドレス（確認）がメールアドレスと一致していません。",
        }}
        maxLength={maxLength}
        txtCaption={txtCaption}
      ></MailAddress>
    </>
  );
});

export default MailAddressAgain;
